<template>
  <div>
    <el-table ref="examApprovalPageTable" :data="examApprovalPage.rows" v-loading="examApprovalLoading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" tooltip-effect="dark" style="width: 100%;" border>
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column show-overflow-tooltip prop="name" label="姓名"></el-table-column>
      <el-table-column show-overflow-tooltip prop="mobile" label="手机号"></el-table-column>
      <el-table-column show-overflow-tooltip prop="courseName" label="考试课程">
        <template slot-scope="scope">
          <span v-if="scope.row.courseName!=null">{{scope.row.courseName}}</span>
          <span v-else>无</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="sequence" label="考试期数" width="120"></el-table-column>
      <el-table-column show-overflow-tooltip prop="examSettingTeacherName" label="审批人" width="120"></el-table-column>
      <el-table-column show-overflow-tooltip prop="sequence" label="操作" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.teacherScore===2" class="operation-style" @click="goExamApproval(scope.row.studentExerciseId)">查看</span>
          <span v-if="scope.row.teacherScore===1" class="operation-style" @click="goExamApproval(scope.row.studentExerciseId)">审批</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="score" label="考试成绩" width="120"></el-table-column>
    </el-table>
    <el-pagination background layout="prev, examApprovalPager, next, jumper,  total, sizes" style="margin-top: 20px;text-align: left;" :total="examApprovalPage.total" :examApprovalPage-size="examApprovalPage.examApprovalPageSize" :current-examApprovalPage="examApprovalPage.examApprovalPageNumber" @size-change="examApprovalSizeChange" @current-change="examApprovalCurrentChange"></el-pagination>
  </div>
</template>
<script>
export default {
  data () {
    return {
      examApprovalLoading: true,
      examApprovalPage: {
        rows: [],
        total: 0,
        examApprovalPageSize: 10,
        examApprovalPageNumber: 1,
        sortName: "",
        sortOrder: "",
        orderBy: ""
      },
      examSearchForm: {}
    };
  },
  props: {
    searchForm: {},
    showFourBlock: false
  },

  methods: {
    goExamApproval (studentExerciseId) {
      this.$router.push({ path: "/examApprovalContent", query: { studentExerciseId: studentExerciseId } })
    },
    examApprovalSizeChange (examApprovalPageSize) {
      this.examApprovalPage.examApprovalPageSize = examApprovalPageSize;
      this.getSubjectiveExamResultexamApprovalPageList();
    },
    examApprovalCurrentChange (examApprovalPageNumber) {
      this.examApprovalPage.examApprovalPageNumber = examApprovalPageNumber;
      this.getSubjectiveExamResultexamApprovalPageList();
    },
    getSubjectiveExamResultexamApprovalPageList () {
      if (!this.showFourBlock) {
        return;
      }
      this.examApprovalLoading = true;
      this.examApprovalPage.rows = [];
      this.examSearchForm.examApprovalPageSize = this.examApprovalPage.examApprovalPageSize;
      this.examSearchForm.examApprovalPageNumber = this.examApprovalPage.examApprovalPageNumber;
      if (this.searchForm.examSettingId != "" && this.searchForm.examSettingId != null) {
        this.examSearchForm.examSettingId = this.searchForm.examSettingId;
      }
      if (typeof this.searchForm.courseIds == "object" && this.searchForm.courseIds.length > 0) {
        this.examSearchForm.courseId = this.searchForm.courseIds[2];
      } else {
        this.examSearchForm.courseId = this.searchForm.courseIds;
      }
      if (this.searchForm.name != "" && this.searchForm.name != null) {
        this.examSearchForm.name = this.searchForm.name;
      }

      if (this.searchForm.examSettingTeacherId != "" && this.searchForm.examSettingTeacherId != null) {
        this.examSearchForm.examSettingTeacherId = this.searchForm.examSettingTeacherId;
      }
      this.api.examStudent
        .getSubjectiveExamResultexamApprovalPageList(this.examSearchForm)
        .then(result => {
          this.examApprovalLoading = false;
          this.examApprovalPage.rows = result.data.records;
          this.examApprovalPage.total = result.data.total;
          this.examSearchForm = {};
          this.showFourBlock = false;
          this.$emit("showFourBlockChange", false)
        })
        .catch(error => {
          console.log(error);
        });
    },
    initGetSubjectiveExamResultexamApprovalPageList () {
      this.showFourBlock = false;
      this.examApprovalLoading = true;
      this.examApprovalPage.rows = [];
      this.examSearchForm.examApprovalPageSize = this.examApprovalPage.examApprovalPageSize;
      this.examSearchForm.examApprovalPageNumber = this.examApprovalPage.examApprovalPageNumber;
      if (this.searchForm.examSettingId != "" && this.searchForm.examSettingId != null) {
        this.examSearchForm.examSettingId = this.searchForm.examSettingId;
      }
      if (typeof this.searchForm.courseIds == "object" && this.searchForm.courseIds.length > 0) {
        this.examSearchForm.courseId = this.searchForm.courseIds[2];
      } else {
        this.examSearchForm.courseId = this.searchForm.courseIds;
      }
      if (this.searchForm.name != "" && this.searchForm.name != null) {
        this.examSearchForm.name = this.searchForm.name;
      }

      if (this.searchForm.examSettingTeacherId != "" && this.searchForm.examSettingTeacherId != null) {
        this.examSearchForm.examSettingTeacherId = this.searchForm.examSettingTeacherId;
      }
      this.api.examStudent
        .getSubjectiveExamResultexamApprovalPageList(this.examSearchForm)
        .then(result => {
          this.examApprovalLoading = false;
          this.examApprovalPage.rows = result.data.records;
          this.examApprovalPage.total = result.data.total;
          this.examSearchForm = {};
        })
        .catch(error => {
          console.log(error);
        });
    },

  },
  watch: {
    "showFourBlock": {
      // handler (newVal) {
      // console.log("val",val)
      // if(val){
      //   this.getSubjectiveExamResultexamApprovalPageList();
      // }
      // deep: true,
      // immediate: true,
      // }
    },
    "searchForm.courseIds" (val, oldVal) {
      this.getSubjectiveExamResultexamApprovalPageList();
    },
    "searchForm.examSettingId" (val, oldVal) {
      this.getSubjectiveExamResultexamApprovalPageList();
    },
    "searchForm.examSettingTeacherId" (val, oldVal) {
      this.getSubjectiveExamResultexamApprovalPageList();
    },
    "searchForm.name" (val, oldVal) {
      this.getSubjectiveExamResultexamApprovalPageList();
    }
  },
  mounted () {
    this.initGetSubjectiveExamResultexamApprovalPageList();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/fullTruthModelTest/examApproval.vue